import React from 'react';
import './RoundedDiv.css';

function RoundedDiv({
  width = '100%',
  bgColor = 'var(--main-color)',
  className = '',
  rotation = '',
  height = '3.1vw',
  radius = '900vw',
}) {
  return (
    <div
      style={{
        '--bg-color': bgColor,
        '--rotate': rotation,
        '--width': width,
        '--height': height,
        '--radius': radius,
      }}
      className={'rounded-div ' + className}
    />
  );
}

export default RoundedDiv;
